// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"map-edit"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M13.5 19.7865L13.5008 22.4999H16.2134L20.164 18.5493L17.4506 15.8359L13.5 19.7865Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15 6.5L9 3L3 6.5V20L9 17.5M15 6.5L21 4V10M15 6.5V12M9 17.5V3.5M9 17.5L10.5 18.375","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M17.4506 15.836L13.5 19.7866L13.5008 22.5H16.2134L20.164 18.5494M17.4506 15.836L19.7866 13.5L22.5 16.2134L20.164 18.5494M17.4506 15.836L20.164 18.5494","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-map-edit')
export default class MapEditIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-edit',
    }
  }
}
